var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "span",
        {
          staticClass: "tableSettingsBtn",
          staticStyle: { position: "absolute", left: "8px" },
          style: { top: _vm.position === "top" ? "42px" : "10px" },
        },
        [
          _c("a-icon", {
            directives: [
              {
                name: "b-modal",
                rawName: "v-b-modal.tableColumns",
                modifiers: { tableColumns: true },
              },
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  theme: _vm.isDarkMode ? "light-border" : "google",
                },
                expression:
                  "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
              },
            ],
            style: { color: "#3699FF" },
            attrs: {
              id: "tableSettingsButton",
              content: _vm.$t("message.tableSettingTippy"),
              "data-v-step": "12",
              type: "setting",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-table", {
        staticClass: "m-0 table-custom custom-table",
        attrs: {
          columns: _vm.columns,
          dataSource: _vm.getData(),
          locale: { emptyText: _vm.$t("message.noLiveSupportFound") },
          pagination: false,
          rowClassName: _vm.rowClassName,
          rowKey: "_id",
          size: "small",
          customRow: _vm.customRow,
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u(
          [
            {
              key: "fullname",
              fn: function (data, item) {
                return _c(
                  "div",
                  {},
                  [
                    !!item.whatsappNumber
                      ? _c(
                          "md-icon",
                          { style: { color: "green", fontSize: "18px" } },
                          [_vm._v("whatsapp")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.fullname))]),
                  ],
                  1
                )
              },
            },
            _vm._l(_vm.inputs, function (input, i) {
              return {
                key: input._id,
                fn: function (data) {
                  return _c("div", { key: i, staticClass: "ellipsis" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getInputValue(data, input)) +
                        "\n        "
                    ),
                  ])
                },
              }
            }),
            {
              key: "customDate",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    key:
                      "customDate-(" + item._id + ")(" + _vm.$i18n.locale + ")",
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("dateShorted")(item.createdDate)) +
                        "\n        "
                    ),
                  ]
                )
              },
            },
            {
              key: "agents",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                      }",
                      },
                    ],
                    key: "agents-(" + item._id + ")(" + _vm.$i18n.locale + ")",
                    attrs: {
                      content: (item.users || [])
                        .filter(function (o) {
                          return "null" !== o || null != o
                        })
                        .map(function (id) {
                          return _vm.idToName(id)
                        })
                        .join(", "),
                    },
                  },
                  [
                    (item.users || []).length === 0 && item.status === "lost"
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "background-color": "#faaaf0",
                              color: "#ffffff",
                              "border-radius": "6px",
                              padding: "2px",
                              "text-align": "center",
                              "font-weight": "400",
                              "font-family": "Poppins",
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("message.agentDown")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm.calculateDate(item)
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "background-color": "#a581bc",
                              color: "#ffffff",
                              "border-radius": "6px",
                              padding: "2px",
                              "text-align": "center",
                              "font-weight": "400",
                              "font-family": "Poppins",
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("message.delayChat")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          (item.users || [])
                            .filter(function (o) {
                              return "null" !== o || null != o
                            })
                            .map(function (id) {
                              return _vm.idToName(id).length > 15
                                ? _vm.idToName(id).substring(0, 11) + "..."
                                : _vm.idToName(id)
                            })
                            .join(", ")
                        ) +
                        "\n        "
                    ),
                  ]
                )
              },
            },
            {
              key: "chatDurations",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    key:
                      "chatDurations-(" +
                      item._id +
                      ")(" +
                      _vm.$i18n.locale +
                      ")",
                  },
                  [
                    item.status === "new" && (item.users || []).length === 0
                      ? _c("PassedTimeCounter", {
                          attrs: { date: item.createdDate, suffix: " saniye" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    item.status === "active" && (item.users || []).length > 0
                      ? _c("PassedTimeCounterTimeFormat", {
                          attrs: { date: item.connectedDate },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              },
            },
            {
              key: "actions",
              fn: function (data, item) {
                return _c(
                  "div",
                  {
                    key: "actions-(" + item._id + ")(" + _vm.$i18n.locale + ")",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-end",
                        staticStyle: { "margin-right": "-10px !important" },
                      },
                      [
                        (item.users || []).length === 0 || _vm.fakeMode
                          ? _c(
                              "md-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                                  },
                                ],
                                staticClass: "custom-button",
                                attrs: {
                                  id: "joinChat",
                                  content: _vm.$t("message.join"),
                                  "data-v-step": "16",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.join(item)
                                  },
                                },
                              },
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "#49c550",
                                  },
                                  attrs: { theme: "filled", type: "message" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              title: "",
                              trigger: "click",
                            },
                          },
                          [
                            _c("template", { slot: "content" }, [
                              _c("div", { staticClass: "content" }, [
                                (item.users || []).filter(function (w) {
                                  return w === _vm.user._id
                                }).length === 0 &&
                                !_vm.observing.includes(item._id)
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex flex-row" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-start",
                                          },
                                          [_c("watch-icon")],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-end pl-3 popoverFont cursorPointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.observe(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("message.watch")
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (item.users || []).filter(function (w) {
                                  return w === _vm.user._id
                                }).length === 0
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex flex-row mt-3" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-start",
                                          },
                                          [_c("open-chat")],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-end pl-3 popoverFont cursorPointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.join(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(_vm.$t("message.join")) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "d-flex flex-row" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-start",
                                          },
                                          [_c("open-chat")],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-end pl-3 popoverFont cursorPointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.join(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(_vm.$t("message.open")) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-row mt-3" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "justify-content-start" },
                                      [_c("private-message-icon")],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isRoot ||
                                    _vm.user.role.permissions
                                      .map(function (x) {
                                        return x.name
                                      })
                                      .includes("visitor.block")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-end pl-3 popoverFont cursorPointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.pm(item._id)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.directMessage"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-row mt-3" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "justify-content-start" },
                                      [_c("block")],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.isRoot ||
                                    _vm.user.role.permissions
                                      .map(function (x) {
                                        return x.name
                                      })
                                      .includes("visitor.block")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "justify-content-end pl-3 popoverFont cursorPointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.ban(item._id)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("message.block")
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "custom-button",
                                attrs: { "data-v-step": "15" },
                              },
                              [_c("Actions")],
                              1
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "a-popover",
                          { attrs: { title: "", trigger: "click" } },
                          [
                            _c("template", { slot: "content" }, [
                              _c(
                                "div",
                                { staticClass: "px-2" },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "mb-3" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticStyle: {
                                            color: "#9ba2b6",
                                            "font-weight": "bold",
                                          },
                                          attrs: { md: "6" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.country")) +
                                              ":\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { md: "6" } }, [
                                        _vm._v(
                                          _vm._s(
                                            item.geoLocation
                                              ? item.geoLocation.country
                                              : "N/A"
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.$_.get(item, "geoLocation.city", false)
                                    ? _c(
                                        "b-row",
                                        { staticClass: "mb-3" },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticStyle: {
                                                color: "#9ba2b6",
                                                "font-weight": "bold",
                                              },
                                              attrs: { md: "6" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.city")) +
                                                  ":\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("b-col", { attrs: { md: "6" } }, [
                                            _vm._v(
                                              _vm._s(item.geoLocation.city)
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mb-3" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticStyle: {
                                            color: "#9ba2b6",
                                            "font-weight": "bold",
                                          },
                                          attrs: { md: "6" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.browser")) +
                                              ":\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { md: "6" } }, [
                                        _vm._v(
                                          _vm._s(
                                            item.visitor.browser
                                              ? item.visitor.browser
                                              : _vm.getUserAgentInfo(
                                                  item.userAgent,
                                                  "browser"
                                                )
                                          ) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mb-3" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticStyle: {
                                            color: "#9ba2b6",
                                            "font-weight": "bold",
                                          },
                                          attrs: { md: "6" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.os")) +
                                              ":\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { md: "6" } }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              item.visitor.os
                                                ? item.visitor.os
                                                : _vm.getUserAgentInfo(
                                                    item.userAgent,
                                                    "os"
                                                  )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mb-3" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticStyle: {
                                            color: "#9ba2b6",
                                            "font-weight": "bold",
                                          },
                                          attrs: { md: "6" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.visitStart")
                                            ) +
                                              ":\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { md: "6" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("date")(item.createdDate)
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "custom-button",
                                attrs: { "data-v-step": "14" },
                              },
                              [_c("Information")],
                              1
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        ((item.users || []).filter(function (w) {
                          return w === _vm.user._id
                        }).length === 0 &&
                          !_vm.observing.includes(item._id)) ||
                        _vm.fakeMode
                          ? _c(
                              "md-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                                  },
                                ],
                                staticClass: "custom-button",
                                attrs: {
                                  content: _vm.$t("message.watch"),
                                  "data-v-step": "13",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.observe(item)
                                  },
                                },
                              },
                              [
                                _c("a-icon", {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "#49c550",
                                  },
                                  attrs: { theme: "filled", type: "eye" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.selectedItem
        ? _c(
            "div",
            {
              style: {
                top: _vm.contextOpt.top + "px",
                left: _vm.contextOpt.left + "px",
              },
              attrs: { id: "context-menu" },
              on: {
                blur: function ($event) {
                  _vm.selectedItem = null
                },
                mouseleave: function ($event) {
                  _vm.selectedItem = null
                },
              },
            },
            [
              _c("div", { staticClass: "d-flex flex-column" }, [
                (_vm.selectedItem.users || []).length === 0 || _vm.fakeMode
                  ? _c(
                      "div",
                      {
                        staticClass: "ctx-btn",
                        staticStyle: { "margin-left": "0 !important" },
                        attrs: { id: "joinChat" },
                        on: {
                          click: function ($event) {
                            return _vm.join(_vm.selectedItem)
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.join").toUpperCase())),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ((_vm.selectedItem.users || []).filter(function (w) {
                  return w === _vm.user._id
                }).length === 0 &&
                  !_vm.observing.includes(_vm.selectedItem._id)) ||
                _vm.fakeMode
                  ? _c(
                      "div",
                      {
                        staticClass: "ctx-btn",
                        on: {
                          click: function ($event) {
                            return _vm.observe(_vm.selectedItem)
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.watch").toUpperCase())),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-end mt-3",
          staticStyle: { "margin-bottom": "100px" },
        },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.totalChatCount,
              "data-v-step": "17",
              pageSizeLocalStorageKey: "chat-list-page-size",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "tableColumns", title: _vm.$t("message.tableSettings") },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("message.tableSettingsInfo")))]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "tableSettings" },
            _vm._l(_vm.defaultCols, function (col, i) {
              return _c(
                "li",
                { key: col.name, staticClass: "tableSettingsChild" },
                [
                  col.name !== "actions"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: {
                                disabled:
                                  Object.values(_vm.tableCols).filter(function (
                                    x
                                  ) {
                                    return x === true
                                  }).length > 7 &&
                                  !_vm.tableCols[col.name] &&
                                  _vm.customLoginFormEnabled,
                              },
                              on: { input: _vm.toLocalStorage },
                              model: {
                                value: _vm.tableCols[col.name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableCols, col.name, $$v)
                                },
                                expression: "tableCols[col.name]",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  col.title ? col.title : _vm.titleEmpty()
                                ) + "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }